import { z } from 'zod';

const SUPPLIERS_MODE = ['view', 'select', 'prioritize'] as const;
export const SUPPLIER_SORT_FIELDS = ['status', 'name'] as const;

export const zodSuppliersSearchSchema = z.object({
  action: z.enum(SUPPLIERS_MODE).default('view').catch('view'),
  planActivation: z.uuid().optional().catch(undefined),
  requestActivation: z.uuid().optional().catch(undefined),
  requestIntegration: z.boolean().optional().catch(undefined),
  savedFilterId: z.uuid().optional().catch(undefined),
  selectedCompanyId: z.uuid().optional().catch(undefined),
  sortField: z.enum(SUPPLIER_SORT_FIELDS).default('status').catch('status'),
});

export const suppliersSearchDefaults = zodSuppliersSearchSchema.parse({});

export type SuppliersMode = (typeof SUPPLIERS_MODE)[number];
export type SupplierSortField = (typeof SUPPLIER_SORT_FIELDS)[number];
